import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleClothStock } from '../../../Store/PHPSlice/clothStock';
import PreviewIcon from '@mui/icons-material/Preview';

const TableBodyLoc = ({
    serialNumber,
    id,
    dt,
    baleId,
    clothId,
    clothNm,
    locId,
    locNm,
    totmtr,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/ClothStkEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this Cloth Stock?");

        // If user confirms, proceed with deletion
        // if (isConfirmed) {
        //     dispatch(deleteSingleClothStock(id))
        //         .then(() => {
        //             // Reload the page to show updated results
        //             toast("Cloth Stock Deleted");
        //             window.location.reload();
        //         })
        //         .catch((error) => {
        //             // Handle any errors that occur during the deletion process
        //             console.error("Error deleting Item:", error);
        //             toast.error("Failed to delete Item");
        //         });
        // }
    };

    const handleViewClick = () => {
        const url = [locId, clothId];
        window.open(`/Bale-Lump-View-location/${url}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {dt}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {clothNm}
                </TableCell>
              
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {locNm}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {totmtr}
                </TableCell>
              

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <PreviewIcon onClick={handleViewClick} className='cursor-pointer' />
                </TableCell>
                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${sts === '1' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell> */}

            </TableRow>
        </>
    );
};

export default React.memo(TableBodyLoc);
